import {Component, OnInit} from '@angular/core';
import {config} from "../config";
import {Page} from "../../api/model/page";
import {AwsService} from "../aws.service";
import {Message} from "primeng/components/common/api";

import * as moment from 'moment';

@Component({
    template: require('./page-list.component.pug'),
    styles: [require('./page-list.component.css')]
})
export class PageListComponent implements OnInit {
    siteId: string;
    
    models: Page[] = [];

    msgs: Message[] = [];    

    deleteConfirm: boolean = false;

    deletePage: string;

    config = config;


    constructor(private _awsService: AwsService) {
        this.siteId = localStorage.getItem('currentSite');
    }

    async ngOnInit() {
        this.models = (await this._awsService.api.sitesSitePagesGet({site: this.siteId})).data.items;
    }

    async confirmDelete(path: string) {
        this.deletePage = path;

        this.deleteConfirm = true;
        console.log(this.deletePage);
    }


    async remove(path:string) {
        await this._awsService.api.sitesSitePagesPathDelete({site: this.siteId, path: this.deletePage});

        this.deleteConfirm = false;

        this.msgs.push({severity: 'success', summary: 'La página se ha eliminado correctamente.'});


    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/pages/page-list.component.ts